import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { userEndpoints } from '../../../../constants';
import { PaginationRequest } from '../../../../types/pagination-request';
import { SortRequest } from '../../../../types/sort-request';
import { HrmUsersResponse } from '../../schemas/hrm-user.schema';

class HrmUserApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getAll = async (data: PaginationRequest & SortRequest<string>): Promise<HrmUsersResponse> => {
    return this.#requestInstance.get(userEndpoints.userV2, { params: data });
  };
}

export const hrmUserApi = new HrmUserApi(axios);
